/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponseData;

  constructor(
    err: PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse";
  }
}

/** @internal */
export const PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$inboundSchema:
  z.ZodType<
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$outboundSchema:
  z.ZodType<
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse
  > = z.instanceof(
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$ {
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$inboundSchema;
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$outboundSchema;
  /** @deprecated use `PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiWorkspaceServiceV1WorkspacesWorkspaceIdShareErrorResponse$Outbound;
}
